import React from 'react';
import { useFormState } from 'react-final-form';
import { FinancialAssistanceStatuses } from 'requisition-service-shared';
import { BillingType, getPaymentPlanOptions } from '@tempus/patient-forms-service-shared';
import FormSingleSelectDropdown from '../../../shared/form/FormSingleSelectDropdown';
import StripeWidget from '../../../../../components/StripeWidget';
import { required } from '../../../shared/form/validators';
import { createUseStyles } from 'react-jss';
import { GrayscalePalette } from '@tcl-boron-colors/colors';

const useStyles = createUseStyles({
  container: {
    padding: '16px',
    border: `1px solid ${GrayscalePalette[400]}`,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
});

type CommercialInsurancePaymentPlanSubformProps = {
  faStatus: FinancialAssistanceStatuses | null;
  stripeCheckoutToken: string;
  setStripeComplete: (value: boolean) => void;
  forceUseSelfPayFlow?: boolean;
};

const CommercialInsurancePaymentPlanSubform: React.FC<CommercialInsurancePaymentPlanSubformProps> = ({
  faStatus,
  stripeCheckoutToken,
  setStripeComplete,
  forceUseSelfPayFlow = false,
}) => {
  const classes = useStyles();
  const formState = useFormState();
  const insuranceCompanyName = formState.values['insuranceCompanyName'];

  const paymentPlanOptions = getPaymentPlanOptions(
    faStatus,
    forceUseSelfPayFlow ? BillingType.SELF_PAY : BillingType.COMMERCIAL_INSURANCE,
  );

  return (
    <>
      {insuranceCompanyName && (
        <div className={classes.container}>
          <FormSingleSelectDropdown
            name="numberOfInstallments"
            label="Number of Installments"
            placeholder="Select Payment Plan"
            validate={required}
            defaultValue={paymentPlanOptions[0]?.value}
            options={paymentPlanOptions as any}
            data-testid="commercial-insurance-payment-plan-dropdown"
          />
          <StripeWidget
            onComplete={() => {
              setStripeComplete(true);
            }}
            checkoutSessionSecret={stripeCheckoutToken}
          />
        </div>
      )}
    </>
  );
};

export default CommercialInsurancePaymentPlanSubform;
